import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';

interface BeFi20GoalSummaryDTO {
  isCompleted: boolean;
  persona: string;
}

interface FetchGoalsParams {
  clientId: number;
}

const fetchBeFi20GoalSummary = async ({
  clientId,
}: FetchGoalsParams): Promise<BeFi20GoalSummaryDTO | null> => {
  const { beFi20Goal } = await authFetch(urlWithParams('/BeFi20/Overview/Goal', { clientId }));

  return beFi20Goal;
};

export const useBeFi20CardQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.beFi20GoalSummary(clientId),
    () => fetchBeFi20GoalSummary({ clientId }),
    {
      cacheTime: 0,
    },
  );
};
